import { Component } from '@angular/core';


@Component({
    selector: 'page-not-found',
    template: '<div>Error</div>',
    standalone: false
})
export class PageNotFoundComponent {

  constructor() { }
 

}
